import { format, formatDistanceToNowStrict, differenceInYears, parseISO } from 'date-fns'
import { fr } from 'date-fns/locale'

export function date(valeur: string | Date | null | undefined): string {
  if (!valeur) return '—'
  const d = typeof valeur === 'string' ? parseISO(valeur) : valeur
  return format(d, 'd MMMM yyyy', { locale: fr })
}

export function dateCourte(valeur: string | Date | null | undefined): string {
  if (!valeur) return '—'
  const d = typeof valeur === 'string' ? parseISO(valeur) : valeur
  return format(d, 'dd/MM/yyyy', { locale: fr })
}

export function heure(valeur: string | Date | null | undefined): string {
  if (!valeur) return '—'
  const d = typeof valeur === 'string' ? parseISO(valeur) : valeur
  return format(d, "dd/MM/yyyy 'à' HH'h'mm", { locale: fr })
}

/** Une date incertaine se lit comme telle : on n'affiche pas un jour inventé. */
export function dateSelonPrecision(
  valeur: string | Date | null | undefined,
  precision: 'JOUR' | 'MOIS' | 'ANNEE' | 'INCERTAINE' = 'JOUR',
): string {
  if (!valeur) return 'Date inconnue'
  const d = typeof valeur === 'string' ? parseISO(valeur) : valeur
  switch (precision) {
    case 'MOIS':
      return format(d, 'MMMM yyyy', { locale: fr })
    case 'ANNEE':
      return format(d, 'yyyy', { locale: fr })
    case 'INCERTAINE':
      return `vers ${format(d, 'MMMM yyyy', { locale: fr })}`
    default:
      return format(d, 'd MMMM yyyy', { locale: fr })
  }
}

export function ilYA(valeur: string | Date | null | undefined): string {
  if (!valeur) return '—'
  const d = typeof valeur === 'string' ? parseISO(valeur) : valeur
  return formatDistanceToNowStrict(d, { locale: fr, addSuffix: true })
}

export function age(dateNaissance: string | null | undefined): string | null {
  if (!dateNaissance) return null
  const annees = differenceInYears(new Date(), parseISO(dateNaissance))
  return `${annees} ans`
}

export function octets(valeur: number | null | undefined): string {
  if (valeur === null || valeur === undefined) return '—'
  if (valeur < 1024) return `${valeur} o`
  if (valeur < 1024 * 1024) return `${Math.round(valeur / 1024)} ko`
  return `${(valeur / (1024 * 1024)).toFixed(1)} Mo`
}

/** Pour les champs de formulaire de type date : « 2026-03-14 ». */
export function pourChampDate(valeur: string | Date | null | undefined): string {
  if (!valeur) return ''
  const d = typeof valeur === 'string' ? parseISO(valeur) : valeur
  if (Number.isNaN(d.getTime())) return ''
  return format(d, 'yyyy-MM-dd')
}
